export const CARD_NAME_WIDTH_SESSIONSTORAGE = 'CARD_NAME_WIDTH_SESSIONSTORAGE';

export const CARD_NAME_WIDTH_DEFAULT_STATE = {};
